import { getStore } from '../store/appModuleStore';
import type { Module } from 'mini-common-schema';
import { mutatorAction } from 'satcheljs';

export const updateModule = mutatorAction('updateAppModule', (newModule: Module) => {
    const store = getStore();
    if (store.module !== newModule) {
        store.module = newModule;
    }
});
